import React from "react";
import { useHoverIntent } from "./useHoverIntent.js";
import { Info } from "lucide-react";
import { T } from "../app/tokens.js";
import { Tooltip } from "./Tooltip.jsx";

// Compact, explicit explanation for KPI headings. The popup is out of flow,
// so it cannot change the card height or move the value.
export function InfoTooltip({ label, text, testId }) {
  const { open, triggerProps } = useHoverIntent();
  const panelId = `${testId}-panel`;
  return (
    <span style={{ position: "relative", display: "inline-flex", flexShrink: 0, alignItems: "center" }}>
      <button
        type="button"
        data-testid={testId}
        aria-label={`About ${label}`}
        aria-describedby={open ? panelId : undefined}
        {...triggerProps}
        style={{ display: "inline-flex", padding: 0, border: 0, background: "transparent", color: T.mid, cursor: "help" }}
      >
        <Info size={13} aria-hidden="true" />
      </button>
      {open && (
        <Tooltip
          id={panelId}
          data-testid={panelId}
          style={{ top: "calc(100% + 8px)", left: 0, width: 260, maxWidth: "min(260px, 80vw)", whiteSpace: "normal", textTransform: "none", letterSpacing: "normal", zIndex: 120 }}
        >
          {text}
        </Tooltip>
      )}
    </span>
  );
}